import { render } from "./categoryTypes.vue?vue&type=template&id=f32a8c56"
import script from "./categoryTypes.vue?vue&type=script&lang=js"
export * from "./categoryTypes.vue?vue&type=script&lang=js"

import "./categoryTypes.vue?vue&type=style&index=0&id=f32a8c56&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__